module.exports = __webpack_public_path__ + "static/img/2.da9f95e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/eng/2.png
// module id = dSzO
// module chunks = 0